<template>
  <a :href="href">
    <slot name="default" />
  </a>
</template>

<script>
export default { name: 'ReloadingRouterLink' };
</script>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({
  to: {
    type: Object,
    required: true,
  },
});

const router = useRouter();

const href = computed(() => router.resolve(props.to).href);
</script>
